import { ConfigProvider, Select } from 'antd'
import { twMerge } from 'tailwind-merge'
import styles from '../../services/styles'
import './Select.css'

const { COLORS } = styles

export function SL_Select({ className, ...rest }) {
    const classes = twMerge(`
        sl-select

        ${className}
    `)

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorText: COLORS.GREEN[900]
                },
            }}
        >
            <Select {...rest} className={classes} />
        </ConfigProvider>
    )
}